export default __webpack_public_path__ + "static/media/Upload_5.c771c6d5.png";